// extracted by mini-css-extract-plugin
export default {"defaultLayoutContainer":"DashboardLayout_defaultLayoutContainer__lsNox"};